import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_120: FaireProductEntity = {
  token: "legacy_prod_abbott-120",
  type: "product",
  name: "Beehive Honey Pot W Lid",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c77c124d76527d3f65e10417923b29df45678f1f190ebb544ec6756d0a8ae15f.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
